// removed by extract-text-webpack-plugin
module.exports = {"finalPriceWrap":"qempo_FinalPrice_finalPriceWrap-3VlLwvF","onlyDefault":"qempo_FinalPrice_onlyDefault-3nGMQBg","mobileWrap":"qempo_FinalPrice_mobileWrap-2a71eG-","pay":"qempo_FinalPrice_pay-2bIfKp5","topWrap":"qempo_FinalPrice_topWrap-2zK9C6c","diy":"qempo_FinalPrice_diy-3TEbroe","textWrap":"qempo_FinalPrice_textWrap-Ks88aX0"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/QuoteStep/components/FinalPrice/FinalPrice.scss
// module id = 1327
// module chunks = 0